<a mat-menu-item class="notification flex align_items_center" tabindex="0">
	<mat-icon color="primary">{{ icon }}</mat-icon>
	<p class="body2">{{ notification.text }}</p>
</a>